import React, { Component } from 'react';
import Script from 'react-load-script';
import Slug from '../slug/slug';

export default class AnyClipPlayer extends Component {
  playerError() {
    console.error('AnyClip script failed to load.');
  }

  playerLoaded() {
    console.log('AnyClip player loaded.');
  }

  playerCreated() {
    console.log(
      'AnyClip script has loaded successfully, waiting on the player now...'
    );
  }

  render() {
    return (
      <div className="siderail-video-module">
        <Slug slugName="Featured Video" className="column" />

        <div
          className="siderail-video-module__player-container"
          ref={this.videoContainerRef}
        >
          <div id="anyclip_player" />

          <Script
            url="https://player.anyclip.com/anyclip-widget/lre-widget/prod/v1/src/lre.js"
            onCreate={this.playerCreated.bind(this)}
            onError={this.playerError.bind(this)}
            onLoad={this.playerLoaded.bind(this)}
            attributes={{
              pubname: 'fastcompanycom',
              widgetname: '001w000001KVCMu_1029'
            }}
          />
        </div>

        {/*
          <h3 className="card__title card__title--small siderail-video-module__player-title-slug">
            {this.videoTitle}
          </h3>
        */}
      </div>
    );
  }
}
